export default __webpack_public_path__ + "static/media/support-icon.59821c1d.svg";